$(document).ready(function () {
  $(window).on("load", function () {
    $("#more-payment-options-link").html("BUY IT NOW");
  });
  // For changing logo
  var header = document.querySelector(".header");

  // Function to check scroll position and add sticky class
  function checkScroll() {
    if (window.scrollY > header.offsetTop) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
  }

  // Initial check in case the page is loaded already scrolled down
  checkScroll();

  // Listen for scroll events
  window.addEventListener("scroll", checkScroll);

  // View more button
  function toggleDescription() {
    var descriptionContent = $("#descriptionContent");
    var viewMoreBtn = $("#viewMoreBtn");

    // Toggle the expanded class
    descriptionContent.toggleClass("expanded");

    // Change button text based on state
    if (descriptionContent.hasClass("expanded")) {
      viewMoreBtn.text("View Less");
    } else {
      viewMoreBtn.text("View More");
    }
  }

  // Attach the toggle function to the button click event
  $("#viewMoreBtn").on("click", toggleDescription);

  // Initialize Slick sliders
  $(".z-9th-sec.z-home-reviews .multicolumn-list").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $("#Slider-template--18221201522918__testinomials_Uz4XyM").slick({
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".z-10th-sec .multicolumn-list").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(".recommended-product-slider .grid.product-grid").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
  ],
});
